import { TranslationStringType } from "@localization/LocalizationContext";
import { SegmentedControlOption } from "@common/components/segmentedControl/SegmentedControl";
import { createViewQuery } from "@common/components/viewSwitcher/viewSwitcherQuery";

// The view switcher identifies views by numeric value; the query string persists the human-readable
// view name (?view=processing-activities|transfers|record|statistics) while the switcher works with these values.
export enum DataProcessingTab {
    ProcessingActivities = 0,
    Transfers = 1,
    Record = 2,
    Statistics = 3,
}

export interface DataProcessingViewAccess {
    canAccessTransfers: boolean;
    canAccessRecord: boolean;
    canAccessStatistic: boolean;
}

const queryByTab: Record<DataProcessingTab, string> = {
    [DataProcessingTab.ProcessingActivities]: "processing-activities",
    [DataProcessingTab.Transfers]: "transfers",
    [DataProcessingTab.Record]: "record",
    [DataProcessingTab.Statistics]: "statistics",
};

const viewQuery = createViewQuery(queryByTab, DataProcessingTab.ProcessingActivities);

export function dataProcessingTabToQuery(tab: DataProcessingTab): string {
    return viewQuery.toQuery(tab);
}

export function dataProcessingTabFromQuery(value: string | null): DataProcessingTab {
    return viewQuery.fromQuery(value);
}

export function buildDataProcessingViews(
    translateString: TranslationStringType,
    access: DataProcessingViewAccess
): Array<SegmentedControlOption<DataProcessingTab>> {
    // Shortened from "processing activities", which is already the page title above the switcher.
    const views = [{ label: translateString("activities"), value: DataProcessingTab.ProcessingActivities }];

    if (access.canAccessTransfers) {
        views.push({ label: translateString("sharings"), value: DataProcessingTab.Transfers });
    }

    if (access.canAccessRecord) {
        views.push({ label: translateString("record"), value: DataProcessingTab.Record });
    }

    if (access.canAccessStatistic) {
        views.push({ label: translateString("statistic"), value: DataProcessingTab.Statistics });
    }

    return views;
}
